import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import QrPlacementPreview from '../../../Components/QrPlacementPreview'
import { printAssetSchema } from '../../../schemas'

export default function New({ account, accounts, navigation, sizes, orientations }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Print Asset"
    >
      <BackLink href="/manage/print_assets">Back to Print Assets</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={printAssetSchema}
          resource="print_asset"
          endpoint="/manage/print_assets"
          backLink="/manage/print_assets"
          submitLabel="Create Print Asset"
          defaultValues={{
            name: '',
            size: '',
            orientation: '',
            asset: null,
            qr_x: 0,
            qr_y: 0,
            qr_width: 40
          }}
        >
          {({ control, errors, watch, setValue }) => {
            const watchedSize = watch('size')
            const watchedOrientation = watch('orientation')
            const watchedQrX = watch('qr_x')
            const watchedQrY = watch('qr_y')
            const watchedQrWidth = watch('qr_width')
            const watchedAsset = watch('asset')

            return (
              <>
                <FormFieldController
                  control={control}
                  name="name"
                  label="Name"
                  required
                  errors={errors}
                />

                <FormFieldController
                  control={control}
                  name="size"
                  label="Paper Size"
                  type="select"
                  options={sizes}
                  required
                  errors={errors}
                />

                <FormFieldController
                  control={control}
                  name="orientation"
                  label="Orientation"
                  type="select"
                  options={orientations}
                  required
                  errors={errors}
                />

                <FormFieldController
                  control={control}
                  name="asset"
                  label="Design File"
                  type="file"
                  accept=".pdf,image/png,image/jpeg"
                  hint="PDF, PNG or JPEG (max 20MB)"
                  errors={errors}
                />

                <QrPlacementPreview
                  assetFile={watchedAsset}
                  assetContentType={watchedAsset instanceof File ? watchedAsset.type : null}
                  size={watchedSize}
                  orientation={watchedOrientation}
                  qrX={parseFloat(watchedQrX) || 0}
                  qrY={parseFloat(watchedQrY) || 0}
                  qrWidth={parseFloat(watchedQrWidth) || 40}
                  onChange={({ qr_x, qr_y, qr_width }) => {
                    setValue('qr_x', qr_x, { shouldDirty: true })
                    setValue('qr_y', qr_y, { shouldDirty: true })
                    setValue('qr_width', qr_width, { shouldDirty: true })
                  }}
                />

                <div className="grid grid-cols-3 gap-4">
                  <FormFieldController
                    control={control}
                    name="qr_x"
                    label="QR X (mm)"
                    type="number"
                    hint="From left edge"
                    errors={errors}
                  />
                  <FormFieldController
                    control={control}
                    name="qr_y"
                    label="QR Y (mm)"
                    type="number"
                    hint="From top edge"
                    errors={errors}
                  />
                  <FormFieldController
                    control={control}
                    name="qr_width"
                    label="QR Size (mm)"
                    type="number"
                    hint="Width & height"
                    errors={errors}
                  />
                </div>
              </>
            )
          }}
        </ResourceForm>
      </div>
    </Layout>
  )
}
